import { useState, useEffect, useCallback } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const COACHING_EVENT = 'coaching-resources-changed';

export const coachingFileUrl = (id) => `${API}/coaching-resources/${id}/file`;
export const coachingPageUrl = (id) => `/programs/vip/coaching/${id}`;

// Jill's Nutrition & Wellness Coaching resources (reloads when the manager saves)
export default function useCoachingResources() {
  const [resources, setResources] = useState([]);
  const load = useCallback(() => {
    fetch(`${API}/coaching-resources`).then((r) => (r.ok ? r.json() : { resources: [] }))
      .then((d) => setResources(d.resources || [])).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    window.addEventListener(COACHING_EVENT, load);
    return () => window.removeEventListener(COACHING_EVENT, load);
  }, [load]);
  return { resources, reload: load };
}

// Checklist category for Jill's Corner, grouped by each resource's group name
export const buildCoachingCategory = (resources) => {
  const groups = [];
  resources.forEach((r) => {
    const title = r.group || 'Other';
    let g = groups.find((x) => x.title === title);
    if (!g) { g = { title, items: [] }; groups.push(g); }
    g.items.push({ id: `coach-${r.id}`, label: r.title, articleUrl: coachingPageUrl(r.id) });
  });
  return {
    id: 'nutrition-coaching',
    name: 'Nutrition & Wellness Coaching',
    blurb: 'Your own coaching resources — tick one to share it in your client\u2019s plan.',
    groups,
  };
};
